import { render, staticRenderFns } from "./tax-text.vue?vue&type=template&id=d32fe554&scoped=true&"
var script = {}
import style0 from "./tax-text.vue?vue&type=style&index=0&id=d32fe554&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32fe554",
  null
  
)

export default component.exports